import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/state/store";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    {
      path: "/",
      component: () => import("@/views/b2c/home"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/reset",
      component: () => import("@/views/reset/reset"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/start",
      component: () => import("@/views/start"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/accounts",
      component: () => import("@/views/accounts"),
      meta: {
        requiresAuth: true,
        allowed_users: [1],
      },
    },
    {
      path: "/users",
      component: () => import("@/views/users"),
      meta: {
        requiresAuth: true,
        allowed_users: [1],
      },
    },
    {
      path: "/klijenti",
      component: () => import("@/views/klijenti"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dobavljaci",
      component: () => import("@/views/dobavljaci"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/artikli",
      component: () => import("@/views/artikli"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/magacin",
      component: () => import("@/views/magacin"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe",
      component: () => import("@/views/zalihe"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-ulaz",
      component: () => import("@/views/zalihe-ulaz"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-izlaz",
      component: () => import("@/views/zalihe-izlaz"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-otpremnice",
      component: () => import("@/views/zalihe-otpremnice"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-povrat",
      component: () => import("@/views/zalihe-povrat"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-otpis",
      component: () => import("@/views/zalihe-otpis"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/zalihe-popis",
      component: () => import("@/views/zalihe-popis"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/narudzbe",
      component: () => import("@/views/narudzbe"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/fakture",
      component: () => import("@/views/fakture"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/knjizne-obavijesti",
      component: () => import("@/views/knjizne-obavijesti"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ponude",
      component: () => import("@/views/ponude"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ugovori",
      component: () => import("@/views/ugovori"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/uplate",
      component: () => import("@/views/uplate"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/isplate",
      component: () => import("@/views/isplate"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/troskovi",
      component: () => import("@/views/troskovi"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sredstva",
      component: () => import("@/views/sredstva"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/nalozi",
      component: () => import("@/views/nalozi"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/biljeske",
      component: () => import("@/views/biljeske"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/kalendar",
      component: () => import("@/views/kalendar"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      component: () => import("@/views/login"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/hr",
      component: () => import("@/views/hr"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/uspjesnost",
      component: () => import("@/views/uspjesnost"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/pozicije",
      component: () => import("@/views/pozicije"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ld",
      component: () => import("@/views/ld"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/evidencija",
      component: () => import("@/views/evidencija"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/podrska",
      component: () => import("@/views/podrska"),
      meta: {
        requiresAuth: true,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!(store.getters.user === null)) {
      if (
        typeof to.meta.allowed_users !== "undefined" &&
        to.meta.allowed_users.length
      ) {
        if (to.meta.allowed_users.indexOf(store.getters.user.id) < 0) {
          store.dispatch("logout");
        } else {
          next();
          return;
        }
      } else {
        next();
        return;
      }
    }
    next("/");
    return;
  } else {
    next();
    return;
  }
});

export default router;
